import React, { useState } from 'react';


// import "../../../components/ad.css"
import '../../components/ad.css';
import { useSelector } from 'react-redux';
import { useCategoryAddMutation, useCounsellorGiveMutation, useCtypeAddMutation, useInitialdataGetQuery, useUploadBlogMutation, useUploadExcelMutation, useUserGiveMutation, useVerifyCounsellorPanMutation, useWithdrawUpdateMutation } from '../../slice/authApiSlice';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { generatePublicUrl, generatePublicUrlLocal } from '../../config/image';
import moment from 'moment';
import { toast } from 'react-toastify';




const columns = [
{ id: 'name', label: 'Name', minWidth: 170 },
  { id: 'code', label: 'Email', minWidth: 200 },
  {
    id: 'population',
    label: 'Coins',
    // minWidth: 170,
    align: 'left',
 
  },
   {
    id: 'size1',
    label: 'Amount',
    minWidth: 100,
    align: 'left',
    
  },
  {
    id: 'size',
    label: 'Give Coins',
    // minWidth: 170,
    align: 'left',
    
  },
   
];


const columnsJob = [
  { id: 'name', label: 'Name', minWidth: 170 },
  { id: 'code', label: 'Email', minWidth: 200 },
  {
    id: 'population',
    label: 'Coins',
    // minWidth: 170,
    align: 'left',
 
  },
   {
    id: 'size1',
    label: 'Amount',
    minWidth: 100,
    align: 'left',
    
  },
  
    {
    id: 'hsd',
    label: 'Give coin',
    // minWidth: 170,
    align: 'left',
    
  },
    {
    id: 'profile',
    label: 'Id proof',
    // minWidth: 170,
    align: 'left',
    
  },
    {
    id: 'Verify',
    label: 'Verify',
    // minWidth: 170,
    align: 'left',
    
  },
   
];


const columnsCalls = [
  { id: 'name', label: 'Skill Name', minWidth: 300},
  { id: 'code', label: 'Skill Id',minWidth: 300},

];



const columnsWithdraw = [
  { id: 'name', label: 'Title'},
  { id: 'code', label: 'Description',},
  {
    id: 'population',
    label: 'Image',
    // minWidth: 170,
    align: 'left',
   
  },
  {
    id: 'size',
    label: 'Date',
    minWidth: 170,
    align: 'left',
  
  },

];


const columnsPayment = [
  { id: 'name', label: 'Name'},
  { id: 'code', label: 'Amount',},
  {
    id: 'population',
    label: 'Order Id',
    // minWidth: 170,
    align: 'left',
   
  },
  {
    id: 'size',
    label: 'Date',
    // minWidth: 170,
    align: 'left',
  
  },
  {
    id: 'density',
    label: 'Status',
    align: 'left',
   
  },
];



const columnsVideos = [
  { id: 'name', label: 'Type Name', minWidth: 300},
  { id: 'code', label: 'Type Id',minWidth: 300},
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}


export default function Users() {
  
  const [collapsed, setCollapsed] = useState(true);
    const [name, setName] = useState("");
        const [coin, setCoin] = useState({});
   const user = useSelector((state) => state.auth.userInfo);
     const {data, isLoading} = useInitialdataGetQuery();
     const [withdrawUpdate] = useWithdrawUpdateMutation();
       const [file, setFile] = useState(null);
       const [uploadExcel, { isLoading: upLoading }] = useUploadExcelMutation();
       const [categoryAdd, { isLoading: isAddingSkill }] = useCategoryAddMutation();
              const [verifyCounsellorPan, { isLoading: isAdding }] = useVerifyCounsellorPanMutation();
       const [ctypeAdd, { isLoading: isTypeLoad }] = useCtypeAddMutation();
       const [userGive, { isLoading: isUserGive }] = useUserGiveMutation();
       const [counsellorGive, { isLoading: isCounseGive }] = useCounsellorGiveMutation();
       const [uploadBlog, { isLoading: isBlogUp }] = useUploadBlogMutation();
       const [title, setTitle] = useState("");
       const [desc, setDesc] = useState("");
       const [images, setImages] = useState([]);
     console.log(data);
const handleVerify = async(id) => {

   try {
       const res = await verifyCounsellorPan(id).unwrap();
         toast.success("Verified successfully");
   } catch (error) {
          toast.error("Something went wrong please relogin");
   }
;
};

     const handleBlogImages = (e) =>{
        setImages([...images, e.target.files[0]]);
    }
     
  const handleAccept = async (id) => {
  await withdrawUpdate(id);
};


 const handleChange = (event) => {
    setName(event.target.value);
  };
  
const handleChangeCoin = (userId, value) => {
  setCoin((prev) => ({
    ...prev,
    [userId]: value,
  }));
};

  const handleSubmit = async () => {
    
    if(name === ""){
        toast.error("Skill name is required")
    }else{
const payload = {
        name,
      };
  
      // console.log(payload);
      
      try {
        const res = await categoryAdd(payload).unwrap();
         toast.success("Skill added successfully");
         setName("")
      } catch (error) {
        // console.log(error);
        toast.error("Something went wrong please relogin")
        setName("")
      }
    }
      
    };


     const handleSubmitCoin = async (userId) => {
      const coin1 = coin[userId];
    if(coin1 === null){
        toast.error("coin is required")
    }else{
const payload = {
        userId,
        coin : parseInt(coin1),
      };

      // console.log(payload);
      
      
      try {
        const res = await userGive(payload).unwrap();
         toast.success("Coins transferred successfully");
         setCoin((prev) => ({
      ...prev,
      [userId]: "",
    }));
      } catch (error) {
        // console.log(error);
        toast.error("Something went wrong please relogin")
         setCoin((prev) => ({
      ...prev,
      [userId]: "",
    }));
      }
    }
      
    };


    const submitBlog = async(e) => {
    try {
           const form = new FormData();
       form.append('blogTitle', title);
       form.append('blogDescription', desc);
       form.append('landingId', data.landing[0]._id)
       images.forEach((image, index) => {
        form.append('image', image)
       })
     const res = await uploadBlog(form);
    //  console.log(res);
     setTitle("");
     setDesc("");
     setImages("")
     
     toast.success("blog uploaded successfully")

    } catch (error) {
         setTitle("");
     setDesc("");
     setImages("")
       toast.error("blog uploaded failed")
    }
    }



    const handleSubmitCounsellorCoin = async (userId) => {
      const coin1 = coin[userId];
    if(coin1 === null){
        toast.error("coin is required")
    }else{
const payload = {
        userId,
        coin : parseInt(coin1),
      };

      // console.log(payload);
      
      
      try {
        const res = await counsellorGive(payload).unwrap();
         toast.success("Coins transferred successfully");
         setCoin((prev) => ({
      ...prev,
      [userId]: "",
    }));
      } catch (error) {
        // console.log(error);
        toast.error("Something went wrong please relogin")
         setCoin((prev) => ({
      ...prev,
      [userId]: "",
    }));
      }
    }
      
    };


const handleSubmitCtype = async () => {
    
    if(name === ""){
        toast.error("ctype is required")
    }else{
const payload = {
        name,
      };
  
      // console.log(payload);
      
      try {
        const res = await ctypeAdd(payload).unwrap();
         toast.success("Type added successfully");
         setName("")
      } catch (error) {
        // console.log(error);
        toast.error("Something went wrong please relogin")
        setName("")
      }
    }
      
    };
  


  const handleUpload = async () => {
    if (!file) return alert("Please choose a file");

    const formData = new FormData();
    formData.append("excel", file);

    try {
      await uploadExcel(formData);
      alert("Upload successful");
      setFile(null);
    } catch (error) {
      console.error(error);
      alert("Upload failed");
    }
  };
     

  return (
  
        <div className='mainPage'>
          {/* Your main content */}
          <div className='upperCard'>
        <div>
                <h2>Hi {user?.firstName} {user?.lastName}, Welcome back</h2>
            <p>Managing users, counsellors, coins, payments, colleges and jobs</p>
        </div>
        <div className='coin'>
            <h2>Coins : Unlimited</h2>
        </div>
          </div>

          

          

          <div className='collegeAddSec'>
               <div className='college'>
                <div className='collegeInner'> 
                  <div className='collegeDesc'>
                    <h2>Users</h2>
                  </div>
                 
                  
                </div>
            
      <TableContainer sx={{ maxHeight: 400 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
       <TableBody>
  {data?.user
    ?.map((college, index) => (
      <TableRow hover role="checkbox" tabIndex={-1} key={college._id || index}>
        <TableCell align='left'>{college?.firstName} {college?.lastName}</TableCell>
        <TableCell align="left">{college?.email}</TableCell>
        <TableCell align="left">{college?.coins}</TableCell>
         <TableCell align="left"><input
  value={coin[college._id] || ""}
  onChange={(e) => handleChangeCoin(college._id, e.target.value)}
  className="reqInput"
  type="text"
/></TableCell>
        <TableCell align="left"><button onClick={() => handleSubmitCoin(college._id)} className='reqBtn'>Coins</button></TableCell>
      </TableRow>
  ))}
</TableBody>
        </Table>
      </TableContainer>
    

               </div>
                 <div className='college'>
                <div className='collegeInner'> 
                  <div className='collegeDesc'>
                    <h2>Counsellors</h2>
                  </div>
                  
                </div>
                  <TableContainer sx={{ maxHeight: 400 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columnsJob.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
       <TableBody>
  {data?.counsellors
    ?.map((college, index) => (
      <TableRow hover role="checkbox" tabIndex={-1} key={college._id || index}>
        <TableCell align='left'>{college?.name}</TableCell>
        <TableCell align='left'>{college?.email}</TableCell>
        <TableCell align="left">{college?.coins}</TableCell>
        <TableCell align="left"><input
  value={coin[college._id] || ""}
  onChange={(e) => handleChangeCoin(college._id, e.target.value)}
  className="reqInput"
  type="text"
/></TableCell>
           <TableCell align="left"><button onClick={() => handleSubmitCounsellorCoin(college._id)} className='reqBtn'>Coins</button></TableCell>
                      <TableCell align="left"><a href={generatePublicUrl(college?.legalId?.[0]?.img)} target="_blank" rel="noopener noreferrer"><img className='bImg1' src={generatePublicUrl(college?.legalId[0]?.img)}/></a></TableCell>
                                 <TableCell align="left">{college?.adminVerified ? <button disabled className='reqBtn'>Verified</button> : <button onClick={() => handleVerify(college._id)} className='reqBtn1'>Verify</button>}</TableCell>
      </TableRow>
  ))}
</TableBody>
        </Table>
      </TableContainer>
               </div>
          </div>



            <div className='collegeAddSec'>
               <div className='college'>
                <div className='collegeInner'> 
                  <div className='collegeDesc'>
                    <h2>Skills</h2>
                  </div>
                  <div className='collegeDesc'>
                    <input className='inputAllField' type='text' value={name} onChange={handleChange} placeholder='Enter skill name'/>
                  <button onClick={handleSubmit}>Add skill</button>
                  </div>
                </div>
                  <TableContainer sx={{ maxHeight: 400 }} >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columnsCalls.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
       <TableBody>
  {data?.categories
    ?.map((calls, index) => (
      <TableRow hover role="checkbox" tabIndex={-1} key={calls._id || index}>
        <TableCell align='left'>{calls?.name}</TableCell>
        <TableCell align='left'>{calls?._id}</TableCell>
      </TableRow>
  ))}
</TableBody>
        </Table>
      </TableContainer>
               </div>
                 <div className='college'>
                <div className='collegeInner'> 
                  <div className='collegeDesc'>
                    <h2>College Types</h2>
                  </div>
                 <div className='collegeDesc'>
                    <input className='inputAllField' type='text' value={name} onChange={handleChange} placeholder='Enter college type'/>
                  <button onClick={handleSubmitCtype}>Add College Type</button>
                  </div>
                </div>
                        <TableContainer sx={{ maxHeight: 400 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columnsVideos.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
       <TableBody>
  {data?.cType
    ?.map((calls, index) => (
      <TableRow hover role="checkbox" tabIndex={-1} key={calls._id || index}>
        <TableCell align='left'>{calls?.name} {calls?.user?.lastName}</TableCell>
        <TableCell align='left'>{calls?._id}</TableCell>
    
      
      </TableRow>
  ))}
</TableBody>
        </Table>
      </TableContainer>
               </div>
          </div>


           <div className='collegeAddSec'>
               <div className='college'>
                <div className='collegeInner'> 
                  <div className='collegeDesc'>
                    <h2>Blogs</h2>
                  </div>
                  <div className='collegeDesc'>
                  {/* <button>Add Blog</button> */}
                  </div>
                </div>
                    <TableContainer sx={{ maxHeight: 400 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columnsWithdraw.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
       <TableBody>
  {data?.landing[0].blog
    ?.map((calls, index) => (
      <TableRow hover role="checkbox" tabIndex={-1} key={calls._id || index}>
        <TableCell align='left'>{calls?.title}</TableCell>
        <TableCell align='left'>{calls?.description}</TableCell>
        <TableCell align="left"><img className='bImg' src={generatePublicUrlLocal(calls?.image)}/></TableCell>
        <TableCell align="left">{moment(calls?.date).format('DD MMM YYYY')}</TableCell>
 
      </TableRow>
  ))}
</TableBody>
        </Table>
      </TableContainer>
               </div>
                 <div className='college'>
                <div className='collegeInner'> 
                  <div className='collegeDesc'>
                    <h2>Add Blog</h2>
                  </div>
                  <div className='collegeDesc'>
          
              
                  </div>
                </div>
                   <div className='addBlogggs'>
                    <h2>Enter Title of new blog</h2>
                    <input type='text' value={title} onChange={(e) => setTitle(e.target.value)} placeholder='Enter title'/>
                    <h2>Enter Description of new blog</h2>
                        <textarea value={desc} onChange={(e) => setDesc(e.target.value)} placeholder='Enter title'/>
                         
                          <h2>Upload blog image</h2>
                      <input type='file' name='image' onChange={handleBlogImages}/> 

                      <button onClick={submitBlog}>Add Blog</button>
                   </div>
                 
               </div>
          </div>
           
           
           
           
          
        </div>
   
  );
}
